import React, { useEffect, useState } from 'react';
import styled from 'astroturf/react';
import { formatDistance } from 'date-fns';
import { Spinner } from 'js/design_system/Spinner';

import routes from 'js/core_pre_webpack/routes';
import SidebarCountryFlag from 'js/liswp/SidebarCountryFlag';
import { Avatar, Card, Header } from './common';
import $image_url from 'js/utils/image_url';

const INITIAL_LIMIT = 5;
const PAGE_SIZE = 10;

const Container = styled.div`
  align-items: center;
  background: #fff;
  display: flex;
  padding: 12px;
`;

const Name = styled.a`
  color: #4b4b4b;
  display: block;
  font-weight: 500;
  font-size: 15px;
  margin: 0;
`;

const PremiumA = styled.img`
  height: 12px;
  margin-right: 8px;
  width: 12px;
`;

const Text = styled.p`
  color: #777;
  font-size: 13px;
  line-height: 1.4;
  margin: 0 0 2px;
`;

const ViewMore = styled.button`
  align-items: center;
  background: #fff;
  border: 0;
  border-top: 1px solid #ddd;
  cursor: pointer;
  color: #0954d3;
  display: flex;
  font-weight: 500;
  height: 36px;
  width: 100%;
`;

const route = routes.read_events_api_v0_bookmarkers_path;

const Bookmarkers: React.FC<{ altLook?: boolean; workId: number | string }> = ({
  altLook,
  workId,
}) => {
  const [limit, setLimit] = useState(INITIAL_LIMIT);
  const [loading, setLoading] = useState(true);
  const [readEvents, setReadEvents] = useState<null | object[]>(null);

  useEffect(() => {
    fetch(route({ work_id: workId, subdomain_param: 'api' }))
      .then((res) => res.json())
      .then((data) =>
        // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'ev' implicitly has an 'any' type.
        data.read_events.filter((ev) => ev != null && ev.reader != null),
      )
      .then(setReadEvents)
      .finally(() => setLoading(false));
    // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const increaseLimit = () => setLimit((l) => l + PAGE_SIZE);

  if (loading) {
    return (
      <Card>
        <Header>Readers</Header>
        <Spinner />
      </Card>
    );
  }

  if (readEvents == null) return null;

  return (
    <Card altLook={altLook}>
      <Header altLook={altLook}>
        <PremiumA src={$image_url('profile/academia-gold.svg')} />
        Readers
      </Header>

      {readEvents.slice(0, limit).map((ev) => {
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'reader' does not exist on type '{}'.
        const { reader, referer } = ev;
        const hasLocation =
          reader.user_location && reader.user_location.country;
        const hasReferer = Boolean(referer);
        const happenedAgo = `${formatDistance(
          // @ts-expect-error ts-migrate(2339) FIXME: Property 'occurred_at' does not exist on type 'obj... Remove this comment to see the full error message
          new Date(ev.occurred_at),
          new Date(),
        )} ago`;

        return (
          <Container>
            <Avatar alt={reader.display_name} src={$image_url(reader.photo)} />

            <div>
              <Name>{reader.display_name}</Name>
              <Text>
                {reader.position}
                {reader.position && reader.department && ', '}
                {reader.department?.university.name}
              </Text>
              <Text>
                {hasLocation && (
                  <SidebarCountryFlag country={reader.user_location.country} />
                )}
                {hasLocation && reader.user_location.country}
                {hasLocation && hasReferer && ' • '}
                {hasReferer && referer.domain}
                {(hasLocation || hasReferer) && ' • '}
                {happenedAgo}
              </Text>
            </div>
          </Container>
        );
      })}
      {limit < readEvents.length && (
        <ViewMore onClick={increaseLimit}>View More</ViewMore>
      )}
    </Card>
  );
};

export default Bookmarkers;
